export default {
  name: "TrendingSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "m30.6 10.14-.7 7.17a1.5 1.5 0 0 1-2.99-.29l.41-4.22-9.27 9.27a1.5 1.5 0 0 1-2.12 0l-4.44-4.44-7.44 7.44a1.5 1.5 0 0 1-2.12-2.12l8.5-8.5a1.5 1.5 0 0 1 2.12 0L17 18.88l8.2-8.2-4.2.41a1.5 1.5 0 0 1-.29-2.99l7.17-.7a2.5 2.5 0 0 1 2.72 2.74z",
  },
}
